import React from 'react';
import Button from '@mui/material/Button';
import FilePresentIcon from '@mui/icons-material/FilePresent';

/**
 * BntTwin Component
 * 
 * A stylized button with an icon and responsive design. It uses Material-UI's Button component 
 * and includes custom styling for different screen sizes.
 * 
 * @returns {JSX.Element} - The rendered button component
 */
const BntTwin = () => {
  return (
    <Button
      sx={{
        left: '10%', // Positions the button 10% from the left edge of its container
        marginTop: '1%', // Adds a top margin of 1% for spacing
        width: '80%', // Sets the button width to 80% of its container
        height: '5%', // Sets the button height to 5% of its container
        backgroundColor: '#fff', // Sets the background color of the button to white
        border: '1px solid #808080', // Adds a 1px solid border with a gray color
        color: '#808080', // Sets the text color to gray
        textTransform: 'none', // Disables text transformation (e.g., no uppercase)
        fontSize: '16px', // Sets the font size to 16px
        fontWeight: 500, // Sets the font weight to 500
        display: 'flex', // Uses flexbox for layout
        alignItems: 'center', // Vertically centers items within the button
        justifyContent: 'center', // Horizontally centers items within the button
        boxShadow: 'none', // Removes the default box shadow
        '&:hover': {
          backgroundColor: '#d3d3d3', // Changes the background color on hover
          borderColor: '#808080', // Changes the border color on hover
        },
        '@media (max-width: 1200px)': {
          display: 'flex', // Ensures the button remains a flex container
          marginLeft: '-6%', // Adjusts left margin for smaller screens
          justifyContent: 'flex-start', // Aligns content to the left
          width: '98%', // Expands button width to 98% of its container
          height: 'auto', // Sets the height to auto to allow flexibility
          fontSize: '14px', // Reduces font size for better readability on smaller screens
          marginTop: '2%', // Adds margin at the top for better spacing on smaller screens
        },
        '@media (max-width: 768px)': {
          display: 'flex', // Ensures the button remains a flex container
          marginLeft: '-6%', // Adjusts left margin for smaller screens
          justifyContent: 'flex-start', // Aligns content to the left
          width: '98%', // Expands button width to 98% of its container
          fontSize: '12px', // Further reduces font size for very small screens
          marginTop: '3%', // Adds margin at the top for better spacing on very small screens
        },
      }}
      startIcon={<FilePresentIcon sx={{ marginBottom: '30px', color: '#808080' }} />} // Adjusts icon positioning and color
    >
      Launch EGSE Digital Twin <br />
      Coming soon
    </Button>
  );
};

export default BntTwin;
